var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-end items-center py-4"},[_c('font-awesome-icon',{staticClass:"text-xl mr-8",attrs:{"icon":['fas', 'bell']}}),_c('div',{staticClass:"w-[40px] h-[40px] bg-indigo-100 rounded-full flex items-center justify-center mr-2"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'suitcase']}})],1),_vm._v(" Company ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }